import { render, staticRenderFns } from "./DetailDev.vue?vue&type=template&id=1a5b4f5a&scoped=true"
import script from "./DetailDev.vue?vue&type=script&lang=js"
export * from "./DetailDev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b4f5a",
  null
  
)

export default component.exports